import loadable from '@loadable/component';

export const AdvntureSiteWrapper = loadable(
  () => import(/* webpackChunkName: "advnture-site" */ './AdvntureSiteWrapper'),
);
